module.exports = __webpack_public_path__ + "img/online.22225e8a.png";